import { render, staticRenderFns } from "./WallsTreeSelect.vue?vue&type=template&id=32e51f7a&"
import script from "./WallsTreeSelect.vue?vue&type=script&lang=js&"
export * from "./WallsTreeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports